<script>
import {mapActions} from "vuex";
import Confirm from "../../../../components/Confirm.vue";
import TraderForm from "./none_report_trader_forms/TraderForm.vue";
import LocationForm from "./none_report_trader_forms/LocationForm.vue";

export default {
  name: "NoneReportTraderAddModal",
  components: {Confirm, TraderForm, LocationForm},
  props: {
    dialog: {
      type: Boolean,
      default: () => false
    },
    /**
     * JWNETマニフェストID
     */
    copySourceId: {
      type: Number,
      default: () => null
    },
    targetSelectableIds: {
      type: Array,
      default: () => [],
    },
    /**
     * 対象区間
     */
    targetSection: {
      type: Number,
      default: () => null,
    },
    /**
     * 対象種別
     * transporter: 運搬業者
     * trader: 運搬先
     * disposer: 処分業者
     */
    targetType: {
      type: String,
      default: () => null
    },
    searchedAt: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      e1: 1,
      trader: null,
      traderLocation: null,
      withSelected: false,
    }
  },
  watch: {
    dialog (val) {
      this.e1 = 1;
      this.trader = null;
      this.traderLocation = null;
      this.withSelected = false;
      this.$nextTick(() => this.$refs.NoneReportTraderFormValidator.reset())
      this.scrollToTop();
      if (val) {
        this.loadNoneReportTrader();
      }
    }
  },
  methods:{
    ...mapActions("DriverTransferNoneReportTrader", {
      fetchNoneReportTrader: "show",
      createNoneReportTrader: "create"
    }),
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit("closeCallback")
    },
    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      let modalOption = {
        title: '確認',
        message: '登録・紐付けをします。よろしいですか？',
        options: {width: 320, isCancelButton: true}
      }
      this.$refs.NoneReportTraderFormValidator.validate().then((result) => {
        if(result) {
          this.$refs.confirm.open(modalOption).then((confirm) => {
            this.$refs.confirm.close()
            if (confirm) {
              this.register();
            }
          })
        } else {
          this.scrollToTop();
          this.e1 = 1;
        }
      })
    },
    /**
     * 戻るボタン クリックイベント
     */
    backButtonClickEvent () {
      this.scrollToTop();
      this.e1 = this.e1 - 1;
    },
    /**
     * 次へボタン クリックイベント
     */
    nextButtonClickEvent () {
      this.e1 = this.e1 + 1;
      this.scrollToTop();
    },
    loadNoneReportTrader () {
      const params = {
        target_section: this.targetSection,
        target_type: this.targetType,
      }
      this.fetchNoneReportTrader({ id: this.copySourceId, params: params }).then((content) => {
        this.trader = content.trader;
        this.traderLocation = content.trader_location;
        if (this.targetType === "disposer") {
          this.traderLocation.location_type = 'only_middle'
        }
      })
    },
    /**
     * 登録処理を行う.
     */
    register () {
      let params = {}
      if (this.targetType === "transporter") {
        params = {
          ...this.trader
        }
      } else {
        params = {
          ...this.trader,
          trader_location_attributes: [
            {
              ...this.traderLocation
            }
          ]
        }
      }
      const parameters = {
        ...this.trader,
        trader_locations_attributes: [],
        jwnet_manifest_ids: this.withSelected ? this.targetSelectableIds : [],
        searched_at: this.searchedAt,
        jwnet_manifest_id: this.copySourceId,
        section_no: this.targetSection,
        target_type: this.targetType,
      }
      if (this.targetType !== "transporter") {
        parameters.trader_locations_attributes = [ { ...this.traderLocation } ]
      }
      this.createNoneReportTrader({ params: parameters }).then(() => {
        this.$emit("registerCallback");
      })
    },
    scrollToTop () {
      const elements = document.getElementsByClassName('noneReportTraderAddBody');
      if (!elements || !elements.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      elements[0].scrollTop = 0;
    },
  }
}
</script>

<template>
  <div>
    <validation-observer ref="NoneReportTraderFormValidator">
      <v-dialog
        :value="dialog"
        width="1300"
        scrollable
        @click:outside="closeButtonClickEvent"
        @close="closeButtonClickEvent"
        @keydown.esc="closeButtonClickEvent"
      >
        <v-form v-if="trader">
          <v-card>
            <v-toolbar
              color="primary"
              dark
              flat
            >
              <v-toolbar-title>
                報告不要業者追加
              </v-toolbar-title>
              <v-spacer />
              <v-toolbar-items>
                <v-btn
                  icon
                  dark
                  @click="closeButtonClickEvent"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text class="noneReportTraderAddBody">
              <v-stepper
                v-model="e1"
                flat
              >
                <v-stepper-items>
                  <v-stepper-content
                    class="pt-2"
                    step="1"
                  >
                    <trader-form :trader.sync="trader" />
                  </v-stepper-content>
                  <v-stepper-content
                    class="pt-2"
                    step="2"
                  >
                    <location-form :trader.sync="trader" :location.sync="traderLocation" />
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-btn
                v-if="e1 > 1"
                color="primary"
                @click="backButtonClickEvent"
              >
                戻る
              </v-btn>
              <v-spacer />
              <v-checkbox
                v-model="withSelected"
                :label="`同じ${targetType === 'transporter' ? '業者名' : '業者名＋事業場名'}のマニフェスト（紐付け未設定）にも紐付けする`"
                class="mr-5"
                dense
                persistent-hint
                persistent-placeholder
                style="font-size: 80%"
              />
              <v-btn
                @click="closeButtonClickEvent"
              >
                閉じる
              </v-btn>
              <v-btn
                v-if="targetType === 'transporter' || e1 > 1"
                :disabled="!trader.agreement"
                color="primary"
                @click="registerButtonClickEvent"
              >
                登録
              </v-btn>
              <v-btn
                v-else
                color="primary"
                @click="nextButtonClickEvent"
              >
                次へ
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </validation-observer>
    <confirm ref="confirm" />
  </div>
</template>
